import { gql } from '@apollo/client'
import { PHOTO_DETAIL_FIELDS } from '../fragments/photoDetail.gql'

export const QB_QUESTION_CREATE_MUTATION = gql`
    mutation qbQuestionCreate($questionCreateInput: QuestionCreateInput!) {
        qbQuestionCreate(questionCreateInput: $questionCreateInput) {
            code
            isSuccess
            errorMessage
            data {
                id
                level
                questionGroupId
                questionTypeId

                isFlaged
                inputType
                content {
                    ... on MCContent {
                        body
                        answers {
                            id
                            body
                        }
                        correctAnswerIds
                        solution
                    }
                }
                tags {
                    id
                    name
                }
                conceptCards {
                    id
                    name
                }
                photoAttachments {
                    ...photoDetail
                }
            }
        }
    }
    ${PHOTO_DETAIL_FIELDS}
`
